"use client";

import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";
import useAuthStore from "~/stores/auth";
import { api } from "~/utils/api";
import { useSession } from "~/utils/auth-client";

const AuthChecker = () => {
	const router = useRouter();
	const pathname = usePathname();
	const { data: session, isPending } = useSession();
	const { data: userData } = api.user.getUser.useQuery(undefined, {
		enabled: !!session,
	});
	const user = useAuthStore((state) => state.user);
	const setUser = useAuthStore((state) => state.setUser);

	useEffect(() => {
		if (session && userData) {
			setUser({
				...session.user,
				...userData,
				name: userData.name || session.user.name || "",
				image: userData.image || session.user.image || "",
			});
		}
	}, [session, userData, setUser]);

	useEffect(() => {
		if (isPending) {
			return;
		}
		if (session?.user?.name && session) {
			return;
		}
		if (!session && pathname === "/auth/login") {
			return;
		}
		if (!session) {
			router.push("/auth/login");
		}
		if (session && user?.name && pathname !== "/auth/profile") {
			router.push("/auth/profile");
		}
	}, [session, isPending, pathname, router, user?.name]);

	return null;
};

export default AuthChecker;
